module.exports = __webpack_public_path__ + "img/TV@3x.c9ff3fb4.png";